<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Delete advert</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong>Are you sure you want to delete this advert?</strong>
            </p>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click.prevent="onDelete"
                >
                    Delete
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        ad: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onDelete() {
            this.$emit('deleted', this.ad.slug);
            this.$emit('close');
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
